import userQueries from '@apis/queries/userQueries';
import useUser from '@hooks/auth/useUser';
import { useQuery } from '@tanstack/react-query';

function useRewardPolicies() {
    const { user } = useUser();
    const { data } = useQuery({
        ...userQueries.assets(),
        enabled: !!user,
    });
    const stampEnabled = !!data?.rewardPolicies
        ?.find((it) => it.rewardType === 'STAMP');

    const pointEnabled = !!data?.rewardPolicies
        ?.find((it) => it.rewardType === 'POINT');

    return {
        stampEnabled,
        pointEnabled,
    };
}

export default useRewardPolicies;
